<template>
  <div>
    
    <div
      class="text-center laptop:my-6 my-6 mobile:my-3 grid laptop:grid-cols-3 desktop:grid-cols-3 largeDesktop:grid-cols-3 mobile:grid-cols-1 items-center mobile:gap-3 laptop:gap-5 relative z-[2]">
      <div></div>
      <div class="text-center">
        <h2 class="mb-0 font-bold font-roboto mobile:text-xl laptop:text-[30px] text-[#333333]">
          {{ getHeading() }}
        </h2>
        <p class="mb-0 font-normal font-roboto mobile:text-base desktop:text-[20px] text-[#333333]">
          {{ getText() }}
        </p>
      </div>
      <div class="laptop:text-right mobile:text-center hidden" v-if="isShowProtectionPlanNumber">
        <p class="mb-0 font-normal font-roboto mobile:text-base desktop:text-lg text-[#666666]">Protection Plan
          Questions
          Call</p>
        <a href="tel:+18338882398"
          class="mb-0 font-bold font-roboto mobile:text-lg laptop:text-xl largeDesktop:text-2xl no-underline text-[#A084E8]">
          (833) 888-2398
        </a>
      </div>
      <div v-if="$route.name == 'commisions'"
        class="flex justify-center tablet:justify-end gap-[10px] laptop:text-right mobile:text-center z-10">
        <div
          class="px-[8px] tablet:px-[15px] py-[10px] flex items-center justify-start gap-[10px] tablet:gap-[15px] min-w-[180px] largeDesktop:min-w-[210px] rounded-[10px] shadow-[0_0_10px_0_#00000026] bg-[#fff]">
          <p class="m-0 text-[40px] laptop:text-[50px] font-roboto font-bold leading-tight text-[#F39C12]">
            $
          </p>
          <div>
            <p class="m-0 text-[14px] font-roboto text-left text-[#F39C12]">Total Pending Amount</p>
            <h2 class="m-0 mobile:text-[20px] laptop:text-[24px] largeDesktop:text-[30px] font-roboto font-bold text-left text-[#333333]">
              ${{ $helper.formatAmountMode(this.comissionSummary?.pending_amount ?? 0, 1) }}.<span
                class="text-[16px] laptop:text-[20px] largeDesktop:text-[25px]">{{
                  $helper.formatAmountMode(this.comissionSummary?.pending_amount ?? 0, 2) }}</span>
            </h2>
       
          </div>
        </div>
        <div
        class="px-[8px] tablet:px-[15px] py-[10px] flex items-center justify-start gap-[10px] tablet:gap-[15px] min-w-[180px] largeDesktop:min-w-[210px] rounded-[10px] shadow-[0_0_10px_0_#00000026] bg-[#fff]">
        <p class="m-0 text-[40px] laptop:text-[50px] font-roboto font-bold leading-tight text-[#54B435]">
          $
        </p>
        <div>
          <p class="m-0 text-[14px] font-roboto text-left text-[#54B435]">Total Paid Amount</p>
        
            <h2 class="m-0 mobile:text-[20px] laptop:text-[24px] largeDesktop:text-[30px] font-roboto font-bold text-left text-[#333333]">
              ${{ $helper.formatAmountMode(this.comissionSummary?.paid_amount ?? 0, 1) }}.<span
                class="text-[16px] laptop:text-[20px] largeDesktop:text-[25px]">{{
                  $helper.formatAmountMode(this.comissionSummary?.paid_amount ?? 0, 2) }}</span>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { Modal } from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
export default {
  props: {
    heading: {
      type: String,
      default: 'Welcome',
    },
    text: {
      type: String,
      default: 'Let’s make today productive and achieve some great results',
    },
  },
  components: {
  },
  data() {
    return {
      modal: null,
      user: JSON.parse(localStorage.getItem('user')) ?? null
    };
  },

  computed: {
    ...mapGetters(["userObject","comissionSummary"]),

    isShowProtectionPlanNumber() {
      if (this.$route.name == 'salesHistory') {
        return true
      } else if (this.$route.name == 'commisions') {
        return true
      } else if (
        this.$route.name == 'products'
      ) {
        return true
      } else {
        return false
      }
    },
  },


  watch: {
    userObject: function () {
      this.user = this.userObject
      localStorage.setItem('user', JSON.stringify(this.user))
    },


  },

  methods: {

      
    getText() {

      if (this.$route.name == 'salesHistory') {
        return 'Protection Plans - Sales History'
      } else if (this.$route.name == 'commisions') {
        return 'Protection Plan Commissions Overview'
      } 
      else if (this.$route.name == 'commissionRules') {
        return ''
      } 
      else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Optional NRG Protects Inc Protection Plans'
      } else if (this.$route.name == 'partnerCheckout') {
        return 'Review and complete your payment'
      } else if (this.$route.name == 'omegaListing') {
        return 'Grow your network. Track your success.'
      } else if (this.$route.name == 'contactus') {
        return 'Have a question? Send us a message and our team will get back to you shortly.'
      } else if (
        this.$route.name == 'affiliates'
      ) {
        return 'View and manage all affiliates associated with your account.'
      } else if (
        this.$route.name == 'learningHub'
      ) {
        return 'View training and marketing materials including videos, images, and PDFs.'
      } else {
        return ''
      }
    },

    getHeading() {
      if (this.$route.name == 'salesHistory' || this.$route.name == 'commisions') {
        return 'Protection Plans'
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Protection Plans'
      } else if (
        this.$route.name == 'globalSearch'
      ) {
        return 'Search Results '
      } else if (
        this.$route.name == 'partnerCheckout'
      ) {
        return 'Checkout '
      } else if (
        this.$route.name == 'products'
      ) {
        return 'Protection Plans'
      } else if (
        this.$route.name == 'omegaListing'
      ) {
        return 'Welcome ' + (this.user ? this.user.user.full_name : '')
      } else if (
        this.$route.name == 'contactus'
      ) {
        return 'Contact Us'
      } else if (this.$route.name == 'commissionRules') {
        return 'Commission Rules'
      } else if (
        this.$route.name == 'affiliates'
      ) {
        return 'Affiliate Listing'
      } else if (
        this.$route.name == 'learningHub'
      ) {
        return 'Learning Hub'
      }
      else if (
        this.$route.name == 'networkAffiliate'
      ) {
        return 'Network Tree'
      }
       else {
        return 'Welcome ' + (this.user ? this.user.user.full_name : '')
      }
    }

  },
}
</script>